import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { AuthApi } from "@/api";
import { qk } from "./queryKeys";
import type { User } from "@/types";

export function useMe() {
  return useQuery<User | null>({
    queryKey: qk.me(),
    queryFn: async () => {
      try { return await AuthApi.me(); }
      catch (e) { if ((e as Error & {status?:number}).status === 401) return null; throw e; }
    },
    staleTime: 60_000,
  });
}

export function useLogout() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: () => AuthApi.logout(),
    onSuccess: () => {
      qc.clear();
      window.location.assign("/login");
    },
  });
}
